module.exports = __webpack_public_path__ + "static/esport-207cbf371d57b569f72b5bddc094390e.svg";